import AirDatepicker from 'air-datepicker';
import localeSv from 'air-datepicker/locale/sv';
import { PagingExpander } from "../../Components/Paging/paging-expander.js";

class NewsListPage {

    constructor() {
        const isNewsListPage = document.querySelector('.newslist') !== null;

        if (!isNewsListPage)
            return;

        this.form = document.querySelector('.search-hero__form--news-form');
        this.targetContainer = document.querySelector('#search-result');
        this.result = document.querySelector('#news-search-result');
        this.bindFunctions();
        this.initializeChips();
        new PagingExpander();

        // This is unforgivable
        window.newsFilterDatePickers = this.initializeDatePickers();

        this.initializeSubmitButton();
        this.initializeClearButtons();

        this.form.addEventListener('submit', this.onFormSubmit);
        this.form.addEventListener("change", e => e.currentTarget.requestSubmit());

        this.handlePossibleScroll();
    }

    handlePossibleScroll() {
        const parameters = new URLSearchParams(window.location.search);
        const currentPage = parameters.get('p');

        if (currentPage) {
            const container = this.targetContainer;
            setTimeout(function () {
                container.scrollIntoView({ behavior: 'smooth' });
            }, 250);
        }
    }

    initializeClearButtons() {
        const form = document.querySelector('.search-hero__form--news-form');
        const clearButtons = [...document.querySelectorAll('button[data-newsfilterclear]')];

        clearButtons.forEach((clearButton) => {
            clearButton.addEventListener(`click`, function () {
                clearButton.dataset.newsfilterclear.split(',').forEach((formElementName) => {
                    const formElement = form.querySelector(`[name="${formElementName}"]`);
                    if (formElement) {
                        formElement.value = '';
                    }
                });

                window.newsFilterDatePickers.minDatePicker.clear({ silent: true });
                window.newsFilterDatePickers.minDatePicker.update({
                    maxDate: new Date(),
                    minDate: undefined,
                });

                window.newsFilterDatePickers.maxDatePicker.clear({ silent: true });
                window.newsFilterDatePickers.maxDatePicker.update({
                    maxDate: new Date(),
                    minDate: undefined,
                });

                const allChipRadioButton = document.querySelector('.search-hero__chip-radio#all-pages');
                allChipRadioButton.dispatchEvent(new Event('click'));
                form.dispatchEvent(new Event('submit'));
            });
        });
    }

    initializeSubmitButton() {
        this.form.querySelector("button[type=submit]").addEventListener("click", e => {
            if (e.pointerType) {
                window.scrollTo({ top: this.result.offsetTop });
            }
        });
    }

    addLoadingDots() {
        const result = document.querySelector('#news-search-result');

        result.innerHTML = "";
        const loadingContainer = document.createElement("div");
        const loadingDots = document.createElement("div");
        loadingContainer.classList.add("news-list__loader");

        loadingDots.classList.add("loading-dots");
        for (let i = 0; i < 4; i++) {
            loadingDots.appendChild(document.createElement("div"));
        }
        loadingContainer.appendChild(loadingDots)
        result.appendChild(loadingContainer);
    }

    removeLoadingDots() {
        const loadingDots = document.querySelector(".news-list__loader");
        if (loadingDots) {
            loadingDots.remove();
        }
    }

    initializeDatePickers() {
        let minDatePicker, maxDatePicker;

        const self = this;

        const minDateDefaultValue = document.querySelector("#mindate").dataset.default;
        const maxDateDefaultValue = document.querySelector("#maxdate").dataset.default;

        minDatePicker = new AirDatepicker('#mindate', {
            autoClose: true,
            multipleDates: false,
            //minView: "years",
            locale: localeSv,
            buttons: ['clear'],
            position: "bottom left",
            isMobile: false,
            maxDate: maxDateDefaultValue ? new Date(maxDateDefaultValue) : new Date(),
            selectedDates: minDateDefaultValue ? [new Date(minDateDefaultValue)] : [],
            onSelect({ date }) {
                maxDatePicker.update({
                    minDate: date
                });

                self.form.dispatchEvent(new Event('change'));
            }
        });
        maxDatePicker = new AirDatepicker('#maxdate', {
            autoClose: true,
            multipleDates: false,
            //minView: "years",
            locale: localeSv,
            position: screen.width <= 576 ? "bottom right" : "bottom left",
            buttons: ['clear'],
            isMobile: false,
            maxDate: new Date(),
            selectedDates: maxDateDefaultValue ? [new Date(maxDateDefaultValue)] : [],
            onSelect({ date }) {
                minDatePicker.update({
                    maxDate: date ? date : new Date()
                });

                self.form.dispatchEvent(new Event('change'));
            }
        });

        return { minDatePicker: minDatePicker, maxDatePicker: maxDatePicker };
    }

    initializeChips() {
        const chips = document.querySelector('.search-hero__chips');

        if (!chips) {
            return;
        }

        const radioButtons = [...chips.querySelectorAll('input[type=radio]')];

        radioButtons.forEach((radioButton) => {
            radioButton.addEventListener(`click`, function (e) {
                radioButtons.forEach((r) => {
                    r.parentElement.classList.remove('search-hero__chip--selected');
                    r.parentElement.classList.add('search-hero__chip--inactive');
                    r.checked = false;
                });

                e.target.parentElement.classList.add('search-hero__chip--selected');
                e.target.parentElement.classList.remove('search-hero__chip--inactive');
                e.target.checked = true;
            });
        });
    }

    onFormSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        const formData = new FormData(event.currentTarget);
        const urlParams = new URLSearchParams(formData);
        this.getData(urlParams.toString());
    }

    getData(query) {
        if (this.targetContainer.classList.contains('search-loading'))
            return;

        this.addLoadingDots();

        const url = `${location.pathname}?${query}`;
        history.pushState("", "", url);
        const headers = {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'X-Requested-With': 'XMLHttpRequest'
        };
        fetch(url, {
            method: 'GET',
            headers
        })
            .then(res => res.json())
            .then(this.onFinish)
            .catch(err => console.log(err))
            .finally(this.initializeClearButtons);
    }

    updateChipCounters() {
        const chipCountAll = document.querySelector('.search-hero__chip-count--all');
        const chipCountNews = document.querySelector('.search-hero__chip-count--NewsPage');
        const chipCountPressReleases = document.querySelector('.search-hero__chip-count--PressReleasePage');

        const newsList = document.querySelector('.news-list#search-result');

        const totalNewsPages = Number(newsList.dataset.totalnewspages);
        const totalPressReleases = Number(newsList.dataset.totalpressreleases);

        chipCountNews.innerHTML = `(${totalNewsPages})`;
        chipCountPressReleases.innerHTML = `(${totalPressReleases})`;
        chipCountAll.innerHTML = `(${totalPressReleases + totalNewsPages})`;

        chipCountAll.parentElement.dataset.count = totalPressReleases + totalNewsPages;
        chipCountNews.parentElement.dataset.count = totalNewsPages;
        chipCountPressReleases.parentElement.dataset.count = totalPressReleases;
    }

    onFinish(json) {
        this.removeLoadingDots();
        this.result.innerHTML = json.html;
        this.updateChipCounters();
        window.lazyLoader.update();
        new PagingExpander();
    }

    bindFunctions() {
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.sendData = this.getData.bind(this);
        this.onFinish = this.onFinish.bind(this);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new NewsListPage();
});
